import { memo, useEffect, useRef, useState } from "react"
import { introImagesList } from "../utils/Jsons"
import MemorizedIntroImageItem from "./IntroImageItem";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { finishLoading } from "../actions/ui";


const VideoContainer = styled.video`
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: absolute;
    object-fit: cover !important;
    z-index: 1;
    top: 0;
    left: 0;

`


const IntroductionComponent = () => {

    const containerRef = useRef(null);

    const [visibleImage, setVisibleImage] = useState(0);

    const [animationActive, setAnimationActive] = useState(false);

    const { t } = useTranslation();

    const data: any = t('introduction', { returnObjects: true });

    const dispatch = useDispatch()

    const [introImages] = useState(`${process.env.REACT_APP_CDN}/intro.mov`);

    const handleClick = () => {

        setAnimationActive(true);

        setTimeout(() => {
            setAnimationActive(false);
        }, 1500);
    };

    const cambiarImagen = (direction: any) => {

        handleClick()

        const container: any = containerRef.current;
        const totalImagenes = introImagesList.length;

        let nuevaImagenVisible = visibleImage + direction;

        if (nuevaImagenVisible === -1) {
            nuevaImagenVisible = totalImagenes - 1;
        } else if (nuevaImagenVisible < 1) {
            nuevaImagenVisible = 0;
        } else if (nuevaImagenVisible >= totalImagenes) {
            nuevaImagenVisible = 0;
        }

        const nuevaPosicion = container.children[nuevaImagenVisible].offsetLeft;
        container.scrollTo({ left: nuevaPosicion, behavior: 'smooth' });
        setVisibleImage(nuevaImagenVisible);
    };

    useEffect(() => {

        const intervalo = setInterval(() => {

            const element = document.getElementById('next');

            element?.click()

        }, 5000);

        return () => clearInterval(intervalo);
    }, []);


    return (

        <div className='introduction__container' id="home">

            <div className='introduction__scroll-container'>

                <button key={10} disabled={animationActive} className="introduction__scroll-arrow-go-left" onClick={() => cambiarImagen(-1)}>
                    <span key={11}></span>
                </button>

                <button key={12} disabled={animationActive} id="next" className="introduction__scroll-arrow-go-right" onClick={() => cambiarImagen(1)}>
                    <span key={13}></span>
                </button>

            </div>
            {/* 
            <div className='introduction__works-counter'>

                {
                    data.map((value: any, index: any) => (

                        <Fragment key={value.title}>

                            <button
                                className={`introduction__work-indicator ${value.id === (visibleImage + 1) ? 'introduction__work-indicator-selected' : ''}`}
                                key={value.id + ' dots' + index}
                                onClick={(e) => {

                                    const indexClicked = parseInt(e.currentTarget.textContent!) - 1;

                                    if (visibleImage !== indexClicked) {
                                        cambiarImagen(indexClicked - visibleImage);
                                    }

                                }}
                            >
                                {`0${index + 1}`}
                            </button>

                            <hr key={value.id + ' hr' + index} className='introduction__hr-counter' />

                        </Fragment>

                    ))
                }

            </div> */}


            <div ref={containerRef} className='introduction__content-container' id="proyects-list">

                {
                    data.map((value: any, index: any) => (

                        <MemorizedIntroImageItem item={value} key={value.id + ' images' + index} animationActive={animationActive} />

                    ))
                }

            </div>

            {
                introImages ? (

                    <VideoContainer
                        id="home"
                        autoPlay
                        muted
                        loop
                        playsInline
                        onLoadedData={() => { dispatch(finishLoading()) }}
                    >
                        <source src={introImages} type="video/mp4" />
                    </VideoContainer>

                ) : <></>
            }

        </div>

    )
}

const Introduction = memo(IntroductionComponent);

export default Introduction;